import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useGame } from '../contexts/GameContext';
import { useAuth } from '../contexts/AuthContext';
import GameFlow from '../components/GameFlow';

export default function GamePlay() {
  const { gameSession, leaveGame, isInGame, isLoading } = useGame();
  const navigate = useNavigate();
  const { user } = useAuth();
  
  // Get game data from gameSession if available
  const gameData = gameSession;

  console.log('GamePlay: Rendering with gameSession:', gameSession);
  console.log('GamePlay: isInGame:', isInGame, 'isLoading:', isLoading);
  
  // Debug player role
  useEffect(() => {
    if (gameSession && user) {
      const isHost = gameSession.players?.some(p => p.isHost && p.id === user.id);
      console.log('GamePlay: User is host:', isHost);
    }
  }, [gameSession, user]);

  useEffect(() => {
    console.log('GamePlay: useEffect triggered with isInGame:', isInGame, 
              'gameData exists:', !!gameData, 
              'gameSession exists:', !!gameSession,
              'gameSession status:', gameSession?.status,
              'gameSession statusName:', gameSession?.statusName);
    
    if (!isInGame || !gameData || !gameSession) {
      console.log('GamePlay: Navigating to home because game conditions not met');
      navigate('/');
      return;
    }

    // Navigate to results when game ends
    if (gameData.statusName === 'Completed') {
      console.log('GamePlay: Navigating to results because game is completed');
      navigate('/results');
    }
  }, [isInGame, gameData, gameSession, navigate]);

  const handleLeaveGame = async () => {
    if (window.confirm('Are you sure you want to leave the game? Your progress will be lost.')) {
      await leaveGame();
      navigate('/');
    }
  };

  if (!gameData || !gameSession) {
    return (
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={6} className="text-center">
            <div className="spinner-border text-primary" />
            <p className="mt-2 text-muted">Loading game...</p>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container fluid className="py-3">
      <Row className="mb-3">
        <Col>
          <Card className="border-0 shadow-sm">
            <Card.Body className="py-3">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">{gameData.title}</h5>
                <Button variant="outline-danger" size="sm" onClick={handleLeaveGame}>
                  <i className="fas fa-sign-out-alt me-1"></i>
                  Leave Game
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      <GameFlow gameSession={gameSession} />
    </Container>
  );
}
